// extracted by mini-css-extract-plugin
module.exports = {"btn":"EnableProvider_btn__26iWt"};